const config = {
  sensors: {
    sensorsServerUrl: 'https://sensorsapi.tianyancha.com/sa?project=production',
    sensorsDebug: false,
  },
  sentry: {
    dsn: 'https://172fd873f4c54387a1a583833d96fa28@sentry-prod.jindidata.com/5',
    tracesSampleRate: 0.01,
  },
  logger: {
    clsOrigin: 'https://cls.tianyancha.com',
  },
  zipkin: {
    url: 'http://zipkin.tyc.io/',
    samplerRatio: 0.001,
  },
  xtransit: {
    server: 'ws://inner.xtransit.fronttyc.io:8643',
    appId: 7,
    appSecret: '2e3f9ec92d1088955fbdb74bd622a6b0',
  },
  fetchConfig: {
    capiServer: 'https://capi.tianyancha.com',
    napiServer: 'https://napi-huawei.tianyancha.com',
    gapiServer: 'https://cloud-gateway.tianyancha.com',
  },
  serverDomain: 'https://www.tianyancha.com',
  qifuServerDomain: 'https://www.tianyanqifu.com',
  newsServerDomain: 'https://news.tianyancha.com',
  discussServerDomain: 'https://discuss.tianyancha.com',
  cookieServerSuffix: '.tianyancha.com',
  tokerServerDomain: 'https://sj.tianyancha.com',
  ownServerDomain: 'https://own.tianyancha.com',

  ssrOriginCapi: 'http://cloud-gateway.services.huawei',
  ssrOriginNapi: 'http://inner-napi.services.huawei',
  ssrOriginNode: 'http://inner-napi.services.huawei', // TODO 下线，使用 napi
};

module.exports = config;
